import React from 'react';
import { useCurrentUser } from '../contexts/CurrentUserContext';

// Tier 1 #10 (decision D-5): someone removed from a team is not locked out on
// the spot. For 14 days their own account keeps working, and this says so —
// with the way to carry on. The server decides (currentUser.removedFromTeam is
// set only while the grace applies); this only shows it.
export default function RemovedMemberBanner({ onChoosePlan }) {
  const { currentUser } = useCurrentUser();
  const r = currentUser?.removedFromTeam;
  if (!r || !r.endsAt) return null;
  const until = new Date(r.endsAt).toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' });
  const team = r.businessName && r.businessName !== 'Business' ? r.businessName : 'your team';
  return (
    <div data-testid="removed-member-banner" style={{ background: '#fff7ed', borderBottom: '1px solid #fdba74', color: '#7c2d12', padding: '0.55rem 1rem', fontSize: '0.86rem', display: 'flex', gap: '0.75rem', alignItems: 'center', justifyContent: 'center', flexWrap: 'wrap' }}>
      <span>You're no longer a member of {team}. Your own account keeps working until <strong>{until}</strong>.</span>
      <button type="button" onClick={onChoosePlan} style={{ background: '#7c2d12', color: '#fff', border: 'none', borderRadius: 6, padding: '0.3rem 0.8rem', fontWeight: 700, cursor: 'pointer' }}>
        Continue on my own plan
      </button>
    </div>
  );
}
